package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/**
 * Certitude d'identification declaree par le contributeur (#129).
 *
 * Les noms font partie du contrat public. Le defaut PROBABLE cote serialization
 * garde les anciens payloads valides : ne pas envoyer le champ n'est pas une erreur.
 */
@Serializable
enum class CertaintyDto {
    CERTAIN,
    PROBABLE,
    TO_CONFIRM
}
